import { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AppTopBar } from "@/components/AppTopBar";

const canReceive = (role) => role === "OWNER" || role === "ADMIN_INVENTORY";

const DECISIONS = {
  SHORT: [
    { key: "SUPPLIER_WILL_COMPLETE", label: "Supplier Kirim Sisa" },
    { key: "CANCEL_REMAINING", label: "Batalkan Sisa" },
  ],
  OVER: [
    { key: "BONUS_ACCEPTED", label: "Terima Bonus" },
    { key: "OVER_RETURN", label: "Kembalikan Kelebihan" },
  ],
  WRONG_SKU: [
    { key: "WRONG_SKU_RETURN", label: "Tunggu SKU Benar" },
    { key: "WRONG_SKU_CANCEL", label: "Batalkan Outstanding" },
  ],
};

export default function ReceivingDetail() {
  const { id } = useParams();
  const { user } = useAuth();
  const [r, setR] = useState(null);
  const [error, setError] = useState("");
  const isOwner = user?.role === "OWNER";

  const load = useCallback(() => {
    api.get(`/receipts/${id}`).then(({ data }) => setR(data))
      .catch((err) => { console.error(err); setError(formatApiErrorDetail(err.response?.data?.detail)); });
  }, [id]);
  useEffect(() => { load(); }, [load]);

  const decide = async (itemId, decision) => {
    setError("");
    try { await api.post(`/receipts/items/${itemId}/decision`, { decision }); load(); }
    catch (err) { console.error(err); setError(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  if (user && !canReceive(user.role)) {
    return (<div className="app-shell"><AppTopBar active="receiving" /><main className="content"><div className="alert-error" data-testid="access-denied">Akses ditolak.</div></main></div>);
  }

  return (
    <div className="app-shell">
      <AppTopBar active="receiving" />
      <main className="content">
        <Link to="/receiving" className="back-link" data-testid="back-to-list">← Kembali ke daftar</Link>
        {error && <div className="alert-error" data-testid="error-banner">{error}</div>}

        {r && (
          <>
            <section className="panel" data-testid="receiving-detail-panel">
              <div className="panel-head">
                <h2 className="panel-title">Penerimaan {r.receipt_no}</h2>
                <span className={`status-pill ${r.purchase_status === "RECEIVED" ? "on" : "off"}`} data-testid="purchase-status">{r.purchase_status}</span>
              </div>
              <div className="meta-grid">
                <div><span className="meta-label">Receipt No</span><span className="mono" data-testid="receipt-no">{r.receipt_no}</span></div>
                <div><span className="meta-label">Purchase No</span><span className="mono">{r.purchase_no}</span></div>
                <div><span className="meta-label">Penerima</span><span data-testid="received-by">{r.received_by_name}</span></div>
                <div><span className="meta-label">Waktu</span><span>{new Date(r.received_at).toLocaleString("id-ID")}</span></div>
              </div>
            </section>

            <section className="panel" data-testid="receiving-items-panel">
              <h2 className="panel-title">Item & QC</h2>
              <div className="table-scroll">
                <table className="data-table" data-testid="detail-items-table">
                  <thead>
                    <tr><th>SKU</th><th>Outstanding</th><th>Physical</th><th>GOOD</th><th>DAMAGED</th><th>Klasifikasi</th><th>Status</th><th>Posted</th><th>Keputusan</th></tr>
                  </thead>
                  <tbody>
                    {r.items.map((it) => (
                      <tr key={it.id} data-testid={`detail-item-${it.sku_code}`}>
                        <td className="mono">{it.sku_code}{it.wrong_sku_code ? ` (fisik: ${it.wrong_sku_code})` : ""}</td>
                        <td className="mono">{it.outstanding_before}</td>
                        <td className="mono">{it.wrong_qty ?? it.physical_qty}</td>
                        <td className="mono">{it.qc_good_qty}</td>
                        <td className="mono">{it.qc_damaged_qty}</td>
                        <td><span className={`tag-${it.classification === "EXACT" ? "ok" : "warn"}`} data-testid={`classification-${it.sku_code}`}>{it.classification}</span></td>
                        <td><span className={`status-pill ${it.line_status === "HOLD" ? "off" : "on"}`} data-testid={`line-status-${it.sku_code}`}>{it.line_status}</span></td>
                        <td className="mono" data-testid={`posted-${it.sku_code}`}>{it.posted_good_qty + (it.decision?.posted_good_qty || 0)}</td>
                        <td>
                          {it.line_status === "HOLD" && isOwner && (DECISIONS[it.classification] || []).map((d) => (
                            <button key={d.key} className="btn-mini" onClick={() => decide(it.id, d.key)} data-testid={`decision-${d.key}-${it.sku_code}`}>{d.label}</button>
                          ))}
                          {it.line_status === "HOLD" && !isOwner && <span className="hint">Menunggu keputusan OWNER</span>}
                          {it.decision && <span className="tag-ok" data-testid={`decided-${it.sku_code}`}>{it.decision.decision}</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </>
        )}
      </main>
    </div>
  );
}
